import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadAngebotKreditorListStatus: 'idle',
    loadAngebotKreditorListError: undefined as any,
    loadAngebotKreditorListLastArgs: undefined as any,
    loadAngebotKreditorStatus: 'idle',
    loadAngebotKreditorError: undefined as any,
    saveAngebotKreditorStatus: 'idle',
    saveAngebotKreditorError: undefined as any,
    deleteAngebotKreditorStatus: 'idle',
    deleteAngebotKreditorError: undefined as any,

    angebotKreditorList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadAngebotKreditorList = createAsyncThunk('auftragAngebotKreditorSlice/loadAngebotKreditorList', async ({ parentModel, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().auftragAngebotKreditorSlice.loadAngebotKreditorListLastArgs
    if (_.isEqual(lastArgs, { parentModel }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurisangbotkred/?action=gte&MIN_AUFTRAGID=${parentModel.HDR_ID}&MAX_AUFTRAGID=${parentModel.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { parentModel }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadAngebotKreditorListStatus } = getState().auftragAngebotKreditorSlice
        return loadAngebotKreditorListStatus !== 'pending'
    }
})

export const loadAngebotKreditor = createAsyncThunk('auftragAngebotKreditorSlice/loadAngebotKreditor', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurisangbotkred/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadAngebotKreditorStatus } = getState().auftragAngebotKreditorSlice
        return loadAngebotKreditorStatus !== 'pending'
    }
})

export const saveAngebotKreditor = createAsyncThunk('auftragAngebotKreditorSlice/saveAngebotKreditor', async ({ angebotKreditor }: any, { rejectWithValue }: any) => {
    let promises = []
    if (angebotKreditor?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/nurisangbotkred/${ angebotKreditor?.HDR_ID }/`,
            prepareData(angebotKreditor),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/nurisangbotkred/`,
            prepareData(angebotKreditor),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveAngebotKreditorStatus } = getState().auftragAngebotKreditorSlice
        return saveAngebotKreditorStatus !== 'pending'
    }
})

export const deleteAngebotKreditor = createAsyncThunk('auftragAngebotKreditorSlice/deleteAngebotKreditor', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/nurisangbotkred/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteAngebotKreditorStatus } = getState().auftragAngebotKreditorSlice
        return deleteAngebotKreditorStatus !== 'pending'
    }
})

const AngebotKreditorSlice = createSlice({
    name: 'auftragAngebotKreditorSlice',
    initialState,
    reducers: {
        resetloadAngebotKreditorListError: (state) => {
            state.loadAngebotKreditorListError = undefined
        },
        resetloadAngebotKreditor: (state) => {
            state.formItem = undefined
            state.loadAngebotKreditorError = undefined
        },
        resetloadAngebotKreditorError: (state) => {
            state.loadAngebotKreditorError = undefined
        },
        resetsaveAngebotKreditor: (state) => {
            state.formItem = undefined
            state.saveAngebotKreditorError = undefined
        },
        resetsaveAngebotKreditorError: (state) => {
            state.saveAngebotKreditorError = undefined
        },
        resetdeleteAngebotKreditorError: (state) => {
            state.deleteAngebotKreditorError = undefined
        },
        removeFromAngebotKreditorListById: (state, action) => {
            state.angebotKreditorList = state.angebotKreditorList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromAngebotKreditorListByIds: (state, action) => {
            state.angebotKreditorList = state.angebotKreditorList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.angebotKreditorList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadAngebotKreditorListStatus = 'preloaded'
            state.loadAngebotKreditorListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.angebotKreditorList = []
            state.loadAngebotKreditorListStatus = 'idle'
            state.loadAngebotKreditorListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadAngebotKreditorList.pending, (state) => {
            state.loadAngebotKreditorListStatus = 'pending'
            state.loadAngebotKreditorListError = undefined
        })
        builder.addCase(loadAngebotKreditorList.fulfilled, (state, action) => {
            state.loadAngebotKreditorListStatus = 'idle'

            if (!action.payload) { return }

            state.loadAngebotKreditorListLastArgs = action.payload.args

            {
                state.angebotKreditorList = action.payload.data

            }
        })
        builder.addCase(loadAngebotKreditorList.rejected, (state, action) => {
            state.loadAngebotKreditorListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadAngebotKreditorListError = action.error.message
            } else {
                state.loadAngebotKreditorListError = action.payload
            }
        })

        builder.addCase(loadAngebotKreditor.pending, (state) => {
            state.loadAngebotKreditorStatus = 'pending'
            state.loadAngebotKreditorError = undefined
        })
        builder.addCase(loadAngebotKreditor.fulfilled, (state, action) => {
            state.loadAngebotKreditorStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.angebotKreditorList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.angebotKreditorList.push(newItem) }
                else { state.angebotKreditorList[i] = { ...state.angebotKreditorList[i], ...newItem } }
            }
        })
        builder.addCase(loadAngebotKreditor.rejected, (state, action) => {
            state.loadAngebotKreditorStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadAngebotKreditorError = action.error.message
            } else {
                state.loadAngebotKreditorError = action.payload
            }
        })

        builder.addCase(saveAngebotKreditor.pending, (state) => {
            state.saveAngebotKreditorStatus = 'pending'
            state.saveAngebotKreditorError = undefined
        })
        builder.addCase(saveAngebotKreditor.fulfilled, (state, action) => {
            state.saveAngebotKreditorStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.angebotKreditorList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.angebotKreditorList.push(newItem) }
                else { state.angebotKreditorList[i] = { ...state.angebotKreditorList[i], ...newItem } }
            }
        })
        builder.addCase(saveAngebotKreditor.rejected, (state, action) => {
            state.saveAngebotKreditorStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveAngebotKreditorError = action.error.message
            } else {
                state.saveAngebotKreditorError = action.payload
            }
        })

        builder.addCase(deleteAngebotKreditor.pending, (state) => {
            state.deleteAngebotKreditorStatus = 'pending'
            state.deleteAngebotKreditorError = undefined
        })
        builder.addCase(deleteAngebotKreditor.fulfilled, (state, action) => {
            state.deleteAngebotKreditorStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.angebotKreditorList = state.angebotKreditorList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.angebotKreditorList = state.angebotKreditorList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteAngebotKreditor.rejected, (state, action) => {
            state.deleteAngebotKreditorStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteAngebotKreditorError = action.error.message
            } else {
                state.deleteAngebotKreditorError = action.payload
            }
        })

    }
})

export const {
    resetloadAngebotKreditorListError,
    resetloadAngebotKreditor,
    resetloadAngebotKreditorError,
    resetsaveAngebotKreditor,
    resetsaveAngebotKreditorError,
    resetdeleteAngebotKreditorError,
    removeFromAngebotKreditorListById,
    removeFromAngebotKreditorListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = AngebotKreditorSlice.actions
export default AngebotKreditorSlice.reducer
